'use client'
import classNames from 'classnames'
import { motion } from 'framer-motion'
import { FC, ReactNode } from 'react'

type ContainerProps = {
  children: ReactNode
  outerClassName?: string
  innerClassName?: string
}

const variants = {
  hidden: {
    opacity: 0,
    transform: 'translateY(40px)',
    filter: 'blur(15px)'
  },
  enter: {
    opacity: 1,
    transform: 'translateY(0px)',
    filter: 'blur(0px)'
  }
}

const Container: FC<ContainerProps> = ({ children, outerClassName, innerClassName }) => {
  return (
    <motion.main
      variants={variants}
      initial="hidden"
      exit="hidden"
      animate="enter"
      transition={{ type: 'ease-in-out', duration: 0.5 }}
      key="KOMMERS.IO"
      className={classNames('pt-[unset] flex flex-col items-center relative', outerClassName)}
    >
      <div className={classNames('max-w-[1432px] w-full max-[1440px]:px-8', innerClassName)}>{children}</div>
    </motion.main>
  )
}

export default Container
